import React, { useState } from "react";
import { Grid, Button, TextField, Modal, Box, Alert, Snackbar } from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import { useThemeContext } from "../context/ThemeContext";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "../axios";

let initialValues = {
  email: "",
};

let changePasswordSchema = Yup.object().shape({
  email: Yup.string().email().required("Email is required!"),
});

const TitleStyles = {
  fontWeight: "600",
  fontSize: "1.5rem",
  marginBottom: "1rem",
  width: 350,
  textAlign: "center",
  justifyContent: "center",
};
const TitleStyles2 = {
  color: "#0066B2",
  fontWeight: "500",
  fontSize: "0.95rem",
  marginTop: "0.5rem",
  marginBottom: "1.5rem",
  width: 350,
  textAlign: "center",
  justifyContent: "center",
};

const fieldStyles = {
  marginBottom: "10px",
  width: "100%",
};

const formStyles = {
  display: "flex",
  flexDirection: "column",
};

const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: '92%',
  boxShadow: 20,
  p: 4,
  borderRadius: "8px",
  padding: "30px",
  border: "0px",
};

function ChangePassword({ open, onClose }) {

  const [callBack, setCallBack] = useState(false);
  const { isDarkMode } = useThemeContext();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  function handleClose() {
    setAlert({
      ...alert,
      showAlert: false,
      severity: "",
      message: "",
    });
  }

  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });

  const sendResetLink = async (values) => {

    try {
      setCallBack(true);
      // eslint-disable-next-line
      const { data, status } = await axios.post('user/sendPasswordToken', values);
      onClose();
      if (status === 200) {
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Please check your mail inbox,Password reset link has been sent!",
        });
        setTimeout(() => {
          setAlert({
            showAlert: false,
            severity: "success",
            message: "",
          });
        }, 16000);
      }
      setCallBack(false);
    } catch (error) {
      setCallBack(false);
      onClose();

      setAlert({
        showAlert: true,
        severity: "error",
        message: `${error?.data
          ? error.data
          : error.data?.message ? error.data?.message : error.response.data ? error.response.data : "Action Failed!"}`,
      });

      setTimeout(() => {
        setAlert({
          showAlert: false,
          severity: "success",
          message: "",
        });
      }, 16000);
    }
  }


  return (
    <>
      <Snackbar
        sx={{ mt: "8vh" }}
        open={alert.showAlert}
        autoHideDuration={15000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={alert.severity}
          sx={{
            fontSize: "16px",
          }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ 
          ...style, 
          width: isMobile ? '92%' : 400, 
          p: isMobile ? 2 : 4,
          bgcolor: isDarkMode ? '#1e293b' : '#fff',
          color: isDarkMode ? '#f1f5f9' : '#000',
        }}>
          <Grid container justifyContent="center">
            <Grid container item direction="column" alignItems="center">
              <Grid
                container
                item
                direction="column"
                alignItems="center"
                minWidth="100%"
              >
                <Grid item sx={{
                  ...TitleStyles,
                  backgroundColor: isDarkMode ? '#1e293b' : '#fff',
                  color: isDarkMode ? '#f1f5f9' : '#000',
                }}>
                  Reset Password
                </Grid>
                <Grid item sx={{
                  ...TitleStyles2,
                  backgroundColor: isDarkMode ? '#1e293b' : '#fff',
                  color: isDarkMode ? '#f1f5f9' : '#0066B2',
                }}>
                  Enter the email to reset your password
                </Grid>
                <Formik
                  initialValues={initialValues}
                  onSubmit={sendResetLink}
                  validationSchema={changePasswordSchema}
                >
                  {({ errors, isValid, touched, dirty }) => (
                    <Form style={formStyles}>
                      <Grid item>
                        <Field
                          style={fieldStyles}
                          name="email"
                          label="Email"
                          as={TextField}
                          variant="outlined"
                          required
                          size="small"
                          margin="dense"
                          error={Boolean(errors.email) && Boolean(touched.email)}
                          helperText={Boolean(touched.email) && errors.email}
                        ></Field>
                      </Grid>

                      <Grid item>
                        <Button
                          sx={{
                            borderRadius: "8px",
                            fontSize: "1rem",
                            fontWeight: "700",
                            height: "2.5rem",
                            marginTop: "1rem",
                            width: '100%',
                          }}
                          color="primary"
                          variant="contained"
                          disabled={!dirty || !isValid || callBack}
                          type="submit"
                          size="large"
                        >
                          Reset Password
                        </Button>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}

export default ChangePassword;
